module.exports = __webpack_public_path__ + "static/media/logo4.2be6a2e5.svg";